import * as types from './actionTypes';
import {apiRequest} from '../utils/request';

export function driverLocationsSuccess(driverLocations){
  return {type: types.LOAD_DRIVER_LOCATIONS_SUCCESS, driverLocations};
}

export function loadDriverLocations() {
  return function (dispatch) {
    dispatch(driverLocationsSuccess({ loaded: false, items: []}));
    return apiRequest(`/api/drivers/locations`)
      .then(x => {
        dispatch(driverLocationsSuccess({ loaded: true, items: Array.from(x.data)}));
      });
  };
}
